// extracted by css-extract-rspack-plugin
export default {"titleBox":"titleBox-R7bh7a","titleFont":"titleFont-bwMcHV"};